<template>
  <modal-notify
    :type="info.type"
    :visible="endModal.isOpen"
    @close="setIsOpen"
    @closed="resetClientEventsEndModal"
  >
    <span slot="title">
      {{ info.title }}
    </span>
    <p>
      {{ info.body }}
    </p>
  </modal-notify>
</template>

<script>
  // vuex
  import {
    mapState,
    mapActions,
    mapMutations,
  } from 'vuex';
  // components
  import ModalNotify from '@/components/Modals/Notify';
  /**
   * This is a template component for a notification modal when completing a Client Events flow.
   *
   * @vuedoc
   * @exports Employer/Modals/FinishClientEvents
   * @category Components
   */
  export default {
    name: 'FinishClientEvents',
    components: { ModalNotify },
    computed: {
      ...mapState({
        endModal: (state) => state.clientEvents.endModal,
      }),
      /**
       * Evaluate different states to determine the modal information.
       *
       * @returns {object}
       */
      info() {
        if (this.endModal.isGoToMarket) {
          if (this.endModal.hasNewCoverage || this.endModal.hasAlternatives) {
            return {
              type: 'info',
              title: 'Marketing request sent to Threeflow!',
              body: 'Our team is setting up your new coverage and plan '
                + 'alternatives (if applicable). Once completed, we’ll send '
                + 'an RFP invite to the carrier(s) and confirmation to your team.',
            };
          }

          return {
            type: 'success',
            title: 'RFP sent to the carrier(s)!',
            body: 'We\'ll send you an email when quotes have been submitted by the carrier(s).',
          };
        }

        if (this.endModal.hasAlternatives) {
          return {
            type: 'info',
            title: 'Renewal request sent to ThreeFlow!',
            body: 'Our team is setting up your plan alternatives. Once completed, we’ll send '
              + 'the renewal request to the carrier(s) and confirmation to you and your team.',
          };
        }

        return {
          type: 'success',
          title: 'Renewal invite sent to carrier(s)!',
          body: 'We\'ll send you an email when quotes have been submitted by the carrier(s).',
        };
      },
    },
    methods: {
      ...mapActions(['resetClientEventsEndModal']),
      ...mapMutations({ setIsOpen: 'SET_END_MODAL_OPEN' }),
    },
  };
</script>
